import { render, staticRenderFns } from "./ITNotSssetsSuspense.vue?vue&type=template&id=81c8e5e0&scoped=true"
import script from "./ITNotSssetsSuspense.vue?vue&type=script&lang=js"
export * from "./ITNotSssetsSuspense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c8e5e0",
  null
  
)

export default component.exports